import React from 'react';
import { Plane, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { openWhatsApp, trackEvent } from '../lib/analytics';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_visa-flight-reserve/artifacts/wo0sp0i8_DummyTicketExperts%20Logo%20%28White%29.png"
                alt="Dummy Ticket Experts"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Your trusted partner for flight reservations and hotel vouchers for visa applications. Professional, fast, and reliable service.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Book Flight Reservation
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('hotel')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Hotel Vouchers
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-start">
                <Plane size={16} className="mr-2 mt-1 flex-shrink-0 text-blue-400" />
                <span>Flight Reservations (Visa)</span>
              </li>
              <li className="flex items-start">
                <Plane size={16} className="mr-2 mt-1 flex-shrink-0 text-blue-400" />
                <span>Flight Reservations (Immigration)</span>
              </li>
              <li className="flex items-start">
                <MapPin size={16} className="mr-2 mt-1 flex-shrink-0 text-orange-400" />
                <span>Hotel Vouchers</span>
              </li>
              <li className="flex items-start">
                <Phone size={16} className="mr-2 mt-1 flex-shrink-0 text-green-400" />
                <span>24/7 Support</span>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://wa.me/919353536633"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackEvent('whatsapp_click', { source: 'footer_link' })}
                  className="flex items-center text-gray-400 hover:text-white transition-colors"
                >
                  <Phone size={16} className="mr-2 text-green-400" />
                  +91 93535 36633
                </a>
              </li>
              <li className="flex items-start text-gray-400">
                <Mail size={16} className="mr-2 mt-1 flex-shrink-0 text-blue-400" />
                <span>support@dummyticketexperts.com</span>
              </li>
              <li className="flex items-start text-gray-400">
                <MapPin size={16} className="mr-2 mt-1 flex-shrink-0 text-orange-400" />
                <span>Serving customers worldwide</span>
              </li>
            </ul>
            <button
              onClick={() => openWhatsApp('https://wa.me/919353536633', 'footer_button')}
              className="mt-4 w-full bg-[#25D366] hover:bg-[#20BA5A] text-white font-semibold py-2 px-4 rounded-lg transition-colors"
            >
              WhatsApp Us
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; {currentYear} Dummy Ticket Experts. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm">
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              Refund Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
